/**
 * @file collegeTransfers.js
 * @author Jake Stark
 * @desc PostGradIndicators report plugin

*/

/**
 * @module collegeTransfers 
 * @desc PostGradIndicators report plugin
 */

define('plugins/collegeTransfers',["underscore", "models", "cardboard/models", "cardboard/collections", "cardboard/util",
        "text!plugins/templates/collegeTransfers_p1TotalTemplate_table.html!strip", "text!plugins/templates/collegeTransfers_transferStudentsByGender_table.html!strip", "text!plugins/templates/collegeTransfers_transferStudentsByAge_table.html!strip", "text!plugins/templates/collegeTransfers_transferStudentsByRace_table.html!strip", "text!plugins/templates/collegeTransfers_beforeXferInstCount_table.html!strip", "text!plugins/templates/collegeTransfers_prevInstMonths_table.html!strip", "text!plugins/templates/collegeTransfers_b4XferDevEducation_table.html!strip", "text!plugins/templates/collegeTransfers_b4XferCredentialCompleted_table.html!strip", "text!plugins/templates/collegeTransfers_b4XferHighestAward_table.html!strip", "text!plugins/templates/collegeTransfers_prevInstUnits_table.html!strip", "text!plugins/templates/collegeTransfers_transferUnits_table.html!strip", "text!plugins/templates/collegeTransfers_afterCredentialCompletionsByBefore_table.html!strip", "text!plugins/templates/collegeTransfers_afterCredentialCompletionsByBefore2_table.html!strip", "text!plugins/templates/collegeTransfers_totalInstCount_table.html!strip", "text!plugins/templates/collegeTransfers_afterXferCredentialCompleted_table.html!strip", "text!plugins/templates/collegeTransfers_afterXferHighestAward_table.html!strip", "cardboard/pluginPieces"
    ],
    function (_, SLEDSModels, CardboardModels, CardboardCollections, Util,
        p1TotalTemplate, transferStudentsByGenderTemplate, transferStudentsByAgeTemplate, transferStudentsByRaceTemplate, beforeXferInstCountTemplate,
        prevInstMonthsTemplate, b4XferDevEducationTemplate, b4XferCredentialCompletedTemplate, b4XferHighestAwardTemplate, prevInstUnitsTemplate, transferUnitsTemplate, afterCredentialCompletionsByBeforeTemplate,afterCredentialCompletionsByBefore2Template, totalInstCountTemplate, afterXferCredentialCompletedTemplate, afterXferHighestAwardTemplate, PluginPieces) {

        console.log("MODULE: collegeTransfers");
        var collegePersistenceVisibilityTest = function (environment) {
            return (environment.dataSources.data.p3AfterXferHighestAward.data.length > 0);
        };
        var noDataMessage = "Sorry, but we don't have any of this data available for the selected criteria.";

        var exports = {

            // options for the demo cats config. since this is a multi-select
            // report, we have to use a different view object, and tell it not to
            // show grades as categories.
            options: {
                orgDetailPane: false,
                noMapSearch: true,
                definitions: true,
                forcedSummaryFilters: ["psxferCOHORTID"]
            },

            // each of these is the configuration that gets passed to a
            // DataBoxPaneView.
            panes: [{
                    title: "Transfer Student Demographics",
                    explanationText: 'This report shows the gender, age, and race/ethnicity of transfer students at Minnesota institutions in the selected year.',

                    openByDefault: true,
                    views: [{
                            type: "template",
                            template: p1TotalTemplate,
                            dataSourceName: "data",
                            errorConditions: [{
                                valuePath: "data.data.p1Total.data[0]",
                                is: undefined,
                                error: {
                                    type: "NoData",
                                    message: "Data is not available for current selection(s)."
                                }
                            }]

                        },
                        {
                            type: "template",
                            template: "<h5>Transfer Students by Gender</h5>"
                        },
                        {
                            // SETUP
                            type: "pie",
                            dataSourceName: "data",
                            dataPath: "p1Gender.data[0].slice",

                            dataShape: "pointsWithinRows",
                            convertDataHashToArray: true,
                            dataDimensions: 1,
                            title: "",

                            // DISPLAY
                            unitString: "%",
                            unitDec: 0,
                            showLegend: true,
                            dataLabels: false,

                            // SERIES (only one series, this is a simple graph)
                            series: [{
                                valuePath: "percent",
                                displayNamePath: "name",
                                longDisplayNamePath: "name",
                            }],
                            errorConditions: [{
                                valuePath: "data",
                                is: null,
                                error: {
                                    type: "NoData",
                                    message: "Data is not available for current selection(s)."
                                }
                            }]

                        },
                        {
                            type: "template",
                            template: transferStudentsByGenderTemplate,
                            dataSourceName: "data",
                            dataSetPath: "p1Gender",
                             errorConditions: [{
                                valuePath: "data",
                                is: null,
                                error: {
                                    type: "NoData",
                                    message: ""
                                }
                            }]
                        },
                        {
                            type: "template",
                            template: "<h5>Transfer Students by Age</h5>"
                        },
                        {
                            // SETUP
                            type: "pie",
                            dataSourceName: "data",
                            dataPath: "p1Age.data[0].slice",

                            dataShape: "pointsWithinRows",
                            convertDataHashToArray: true,
                            dataDimensions: 1,
                            title: "",

                            // DISPLAY
                            unitString: "%",
                            unitDec: 0,
                            showLegend: true,
                            dataLabels: false,

                            // SERIES (only one series, this is a simple graph)
                            series: [{
                                valuePath: "percent",
                                displayNamePath: "name",
                                longDisplayNamePath: "name",
                            }],
                            errorConditions: [{
                                valuePath: "data",
                                is: null,
                                error: {
                                    type: "NoData",
                                    message: "Data is not available for current selection(s)."
                                }
                            }]

                        },
                        {
                            type: "template",
                            template: transferStudentsByAgeTemplate,
                            dataSourceName: "data",
                            dataSetPath: "p1Age",
                             errorConditions: [{
                                valuePath: "data",
                                is: null,
                                error: {
                                    type: "NoData",
                                    message: ""
                                }
                            }]
                        },
                        {
                            type: "template",
                            template: "<h5>Transfer Students by Race/Ethnicity</h5>"
                        },
                        {
                            // SETUP
                            type: "pie",
                            dataSourceName: "data",
                            dataPath: "p1Race.data[0].slice",

                            dataShape: "pointsWithinRows",
                            convertDataHashToArray: true,
                            dataDimensions: 1,
                            title: "",

                            // DISPLAY
                            unitString: "%",
                            unitDec: 0,
                            showLegend: true,
                            dataLabels: false,

                            // SERIES (only one series, this is a simple graph)
                            series: [{
                                valuePath: "values[0].percent",
                                displayNamePath: "name",
                                longDisplayNamePath: "name",
                            }],
                            errorConditions: [{
                                valuePath: "data",
                                is: null,
                                error: {
                                    type: "NoData",
                                    message: "Data is not available for current selection(s)."
                                }
                            }]

                        },
                        {
                            type: "template",
                            template: transferStudentsByRaceTemplate,
                            dataSourceName: "data",
                            dataSetPath: "p1Race",
                             errorConditions: [{
                                valuePath: "data",
                                is: null,
                                error: {
                                    type: "NoData",
                                    message: ""
                                }
                            }]
                        }
                    ]
                },

                  {
                    title: "Activity Prior to Transfer",
                    explanationText: '<p>This report shows data about students <u>prior</u> to their transfer: the number of institutions attended, time at previous institution, enrollment in developmental education, credential completion, and credits accumulated/transferred.</p><p>Developmental education data is only available for students who attended Minnesota institutions.</p>',

                    openByDefault: false,
                    views: [{
                            type: "template",
                            template: "<h5> Number of Institutions Attended Before Transfer Among Those with Known Origin Institution</h5>"
                        },
                        {
                            // SETUP
                            type: "pie",
                            dataSourceName: "data",
                            dataPath: "p2BeforeXferInstCount.data[0].slice",

                            dataShape: "pointsWithinRows",
                            convertDataHashToArray: true,
                            dataDimensions: 1,
                            title: "",

                            // DISPLAY
                            unitString: "%",
                            unitDec: 0,
                            showLegend: true,
                            dataLabels: false,

                            // SERIES (only one series, this is a simple graph)
                            series: [{
                                valuePath: "percent",
                                displayNamePath: "name",
                                longDisplayNamePath: "name",
                            }],
                            errorConditions: [{
                                valuePath: "data",
                                is: null,
                                error: {
                                    type: "NoData",
                                    message: "Data is not available for current selection(s)."
                                }
                            }]

                        },
                        {
                            type: "template",
                            template: beforeXferInstCountTemplate,
                            dataSourceName: "data",
                            dataSetPath: "p2BeforeXferInstCount",
                             errorConditions: [{
                                valuePath: "data",
                                is: null,
                                error: {
                                    type: "NoData",
                                    message: ""
                                }
                            }]
                        },
                        {
                            type: "template",
                            template: "<h6 class='reportSubhead'>Average Number of Institutions Before Transfer</h6> {{data.average}}",
                            dataSourceName: "data",
                            dataPath: "p2BeforeXferInstCount",
                            errorConditions: [{
                               valuePath: "data",
                               is: null,
                               error: {
                                   type: "NoData",
                                   message: ""
                               }
                           }]
                        },
                       
                        {
                            type: "template",
                            template: "<h5> Time at Previous Institution Among Those with Known Origin Institution</h5>"
                        },
                         {
                            // SETUP
                            // one glob = one line series
                            // in each series, one row = one data point
                            type: "bar",
                            dataSourceName: "data",
                            dataSetPath: "p2PrevInstMonths",
                         
                            dataPath: "p2PrevInstMonths.data",

                            // "pointsWithinRows": given that the data is
                            // two-dimensional (meaning an array of arrays, or
                            // similar structure, implying that we have more than
                            // one series to plot) each series is contained in a
                            // "row", like so:
                            //	 +---------+
                            //	 | X X X X |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 +---------+
                            dataShape: "pointsWithinRows",
                            dataDimensions: 2,
                            //convertDataHashToArray: true,

                            // DISPLAY
                            //xAxisLabelPath: "metric[1].name",
                            unitString: "",
                            //  unitPreString: "$",
                            unitDec: 0,
                            showLegend: true,
                            // yAxisMax: 5000,
                            yAxisMaxPath: "yMax",
                            //   yAxisTickInterval: 5,
                            dataLabels: true,
                            //colorByPoint: true,

                            // SERIES
                            // each series has two points, and is an organization
                            series: [{
                                    dataPath: "slice",
                                    valuePath: "count",
                                    seriesDisplayNamePath: "orgName",
                                    displayNamePath: "name",

                                }
                            ],
                             errorConditions: [{
                                valuePath: "data.meta.dataNotAvailableMessage",
                                isNot: null,
                                error: {
                                    type: "NoData",
                                    messagePath: "data.meta.dataNotAvailableMessage"
                                }
                            }] 
                         
                            //errorConditions: [PluginPieces.standardErrorCondition]
                        }, 
                        {
                            type: "template",
                            template: prevInstMonthsTemplate,
                            dataSourceName: "data",
                            dataSetPath: "p2PrevInstMonths",
                             errorConditions: [{
                                valuePath: "data",
                                is: null,
                                error: {
                                    type: "NoData",
                                    message: ""
                                }
                            }]
                        },
                        {
                            type: "template",
                            template: "<h6 class='reportSubhead'>Average Months At Previous Institution</h6> {{data.average}}",
                            dataSourceName: "data",
                            dataPath: "p2PrevInstMonths",
                             errorConditions: [{
                                valuePath: "data",
                                is: null,
                                error: {
                                    type: "NoData",
                                    message: ""
                                }
                            }]
                        }, 
                        {
                            type: "template",
                            template: "<h5> Enrollment in Developmental Education Before Transfer</h5>"
                        }, 
                        {
                            // SETUP
                            type: "pie",
                            dataSourceName: "data",
                            dataPath: "p2B4XferDevEducation.data[0].slice",

                            dataShape: "pointsWithinRows",
                            convertDataHashToArray: true,
                            dataDimensions: 1,
                            title: "",

                            // DISPLAY
                            unitString: "%",
                            unitDec: 0,
                            showLegend: true,
                            dataLabels: false,

                            // SERIES (only one series, this is a simple graph)
                            series: [{
                                valuePath: "percent",
                                displayNamePath: "name",
                                longDisplayNamePath: "name",
                            }],
                            errorConditions: [{
                                valuePath: "data",
                                is: null,
                                error: {
                                    type: "NoData",
                                    message: "Data is not available for current selection(s)."
                                }
                            }]

                        },
                        {
                            type: "template",
                            template: b4XferDevEducationTemplate,
                            dataSourceName: "data",
                            dataSetPath: "p2B4XferDevEducation",
                             errorConditions: [{
                                valuePath: "data",
                                is: null,
                                error: {
                                    type: "NoData",
                                    message: ""
                                }
                            }]
                        },
                        {
                            type: "template",
                            template: "<h6 class='reportSubhead'>Average Number of Developmental Education Credits Attempted for Students Enrolled in Developmental Education Before Transfer</h6> {{data.average}}",
                            dataSourceName: "data",
                            dataPath: "p2B4XferDevEducation",
                             errorConditions: [{
                                valuePath: "data",
                                is: null,
                                error: {
                                    type: "NoData",
                                    message: ""
                                }
                            }]
                        },
                       
                        {
                            type: "template",
                            template: "<h5> Credential Completion Before Transfer</h5>"
                        },
                        {
                            // SETUP
                            type: "pie",
                            dataSourceName: "data",
                            dataPath: "p2B4XferCredentialCompleted.data[0].slice",
                            dataShape: "pointsWithinRows",
                            convertDataHashToArray: true,
                            dataDimensions: 1,
                            title: "",

                            // DISPLAY
                            unitString: "%",
                            unitDec: 0,
                            showLegend: true,
                            dataLabels: false,

                            // SERIES (only one series, this is a simple graph)
                            series: [{
                                valuePath: "percent",
                                displayNamePath: "name",
                                longDisplayNamePath: "name",
                            }],
                            errorConditions: [{
                                valuePath: "data",
                                is: null,
                                error: {
                                    type: "NoData",
                                    message: "Data is not available for current selection(s)."
                                }
                            }]

                        },
                        {
                            type: "template",
                            template: b4XferCredentialCompletedTemplate,
                            dataSourceName: "data",
                            dataSetPath: "p2B4XferCredentialCompleted",
                             errorConditions: [{
                                valuePath: "data",
                                is: null,
                                error: {
                                    type: "NoData",
                                    message: ""
                                }
                            }]
                        },
                        {
                            type: "template",
                            template: "<h5> Highest Credential Completed Before Transfer</h5>"
                        },
                        {
                            type: "bar",
                            dataSourceName: "data",
                          
                            dataSetPath: "p2B4XferHighestAward",
                         
                            dataPath: "p2B4XferHighestAward.data",
                            dataShape: "pointsWithinRows",
                            dataDimensions: 2,
                            //convertDataHashToArray: true,

                            // DISPLAY
                            //xAxisLabelPath: "metric[1].name",
                            unitString: "",
                            unitDec: 0,
                            showLegend: true,
                            // yAxisMax: 5000,
                            yAxisMaxPath: "yMax",
                            dataLabels: true,

                            // SERIES
                            // each series has two points, and is an organization
                            series: [{
                                    dataPath: "slice",
                                    valuePath: "count",
                                    seriesDisplayNamePath: "orgName",
                                    displayNamePath: "name",

                                },
                                {
                                    dataPath: "slice",
                                    valuePath: "count",
                                    seriesDisplayNamePath: "orgName",
                                    displayNamePath: "name",

                                }
                            ],
                            errorConditions: [{
                                valuePath: "data.meta.dataNotAvailableMessage",
                                isNot: null,
                                error: {
                                    type: "NoData",
                                    messagePath: "data.meta.dataNotAvailableMessage"
                                }
                            }] 
                        },
                        {
                            type: "template",
                            template: b4XferHighestAwardTemplate,
                            dataSourceName: "data",
                            dataSetPath: "p2B4XferHighestAward",
                             errorConditions: [{
                                valuePath: "data",
                                is: null,
                                error: {
                                    type: "NoData",
                                    message: ""
                                }
                            }]
                        },

                        {
                            type: "template",
                            template: "<h5>  Credits Accumulated at Previous Institution Among Those with Known Credits at Semester or Quarter-based Schools</h5>"
                        },
                        {
                            // SETUP
                            type: "pie",
                            dataSourceName: "data",
                            dataPath: "p2PrevInstUnits.data[0].slice",
                            dataShape: "pointsWithinRows",
                            convertDataHashToArray: true,
                            dataDimensions: 1,
                            title: "",

                            // DISPLAY
                            unitString: "%",
                            unitDec: 0,
                            showLegend: true,
                            dataLabels: false,

                            // SERIES (only one series, this is a simple graph)
                            series: [{
                                valuePath: "percent",
                                displayNamePath: "name",
                                longDisplayNamePath: "name",
                            }],
                            errorConditions: [{
                                valuePath: "data",
                                is: null,
                                error: {
                                    type: "NoData",
                                    message: "Data is not available for current selection(s)."
                                }
                            }]

                        },
                        {
                            type: "template",
                            template: prevInstUnitsTemplate,
                            dataSourceName: "data",
                            dataSetPath: "p2PrevInstUnits",
                             errorConditions: [{
                                valuePath: "data",
                                is: null,
                                error: {
                                    type: "NoData",
                                    message: ""
                                }
                            }]
                        },
                        {
                            type: "template",
                            template: "<h6 class='reportSubhead'>Average Credits Accumulated at Previous Institution</h6> {{data.average}}",
                            dataSourceName: "data",
                            dataPath: "p2PrevInstUnits",
                             errorConditions: [{
                                valuePath: "data",
                                is: null,
                                error: {
                                    type: "NoData",
                                    message: ""
                                }
                            }]
                        },
                        {
                            type: "template",
                            template: "<h5> Transfer Credits Accepted at Transfer Institution for Semester or Quarter-based Schools</h5>"
                        },
                        {
                            // SETUP
                            type: "pie",
                            dataSourceName: "data",
                            dataPath: "p2TransferUnits.data[0].slice",
                            dataShape: "pointsWithinRows",
                            convertDataHashToArray: true,
                            dataDimensions: 1,
                            title: "",

                            // DISPLAY
                            unitString: "%",
                            unitDec: 0,
                            showLegend: true,
                            dataLabels: false,

                            // SERIES (only one series, this is a simple graph)
                            series: [{
                                valuePath: "percent",
                                displayNamePath: "name",
                                longDisplayNamePath: "name",
                            }],
                            errorConditions: [{
                                valuePath: "data",
                                is: null,
                                error: {
                                    type: "NoData",
                                    message: "Data is not available for current selection(s)."
                                }
                            }]

                        },
                        {
                            type: "template",
                            template: transferUnitsTemplate,
                            dataSourceName: "data",
                            dataSetPath: "p2TransferUnits",
                             errorConditions: [{
                                valuePath: "data",
                                is: null,
                                error: {
                                    type: "NoData",
                                    message: ""
                                }
                            }]
                        },
                        {
                            type: "template",
                            template: "<h6 class='reportSubhead'>Average Transfer Credits Accepted</h6> {{data.average}}",
                            dataSourceName: "data",
                            dataPath: "p2TransferUnits",
                             errorConditions: [{
                                valuePath: "data",
                                is: null,
                                error: {
                                    type: "NoData",
                                    message: ""
                                }
                            }]
                        }, 
                    ]
                }, 

                {
                    title: "Activity After Transfer",
                    explanationText: "<p>This report shows data about students <u>after</u> their transfer: credential completion and the total number of institutions attended.</p>",
                    openByDefault: false,
                    views: [{
                            type: "template",
                            template: "<h5>Credential Completion After Transfer</h5>"
                        },
                        {
                            // SETUP
                            type: "pie",
                            dataSourceName: "data",
                            dataPath: "p3AfterXferCredentialCompleted.data[0].slice",
                            dataShape: "pointsWithinRows",
                            convertDataHashToArray: true,
                            dataDimensions: 1,
                            title: "",

                            // DISPLAY
                            unitString: "%",
                            unitDec: 0,
                            showLegend: true,
                            dataLabels: false,

                            // SERIES (only one series, this is a simple graph)
                            series: [{
                                valuePath: "percent",
                                displayNamePath: "name",
                                longDisplayNamePath: "name",
                            }],
                            errorConditions: [{
                                valuePath: "data",
                                is: null,
                                error: {
                                    type: "NoData",
                                    message: "Data is not available for current selection(s)."
                                }
                            }]

                        },
                        {
                            type: "template",
                            template: afterXferCredentialCompletedTemplate,
                            dataSourceName: "data",
                            dataSetPath: "p3AfterXferCredentialCompleted",
                             errorConditions: [{
                                valuePath: "data",
                                is: null,
                                error: {
                                    type: "NoData",
                                    message: ""
                                }
                            }]
                        },
                        {
                            type: "template",
                            template: "<h5> Incidence of Credential AFTER Transfer by Credential BEFORE Transfer</h5>"
                        },
                        {
                            type: "template",
                            template: afterCredentialCompletionsByBeforeTemplate,
                            dataSourceName: "data",
                            dataSetPath: "p3AfterCredentialCompletionsByBefore",
                             errorConditions: [{
                                valuePath: "data",
                                is: null,
                                error: {
                                    type: "NoData",
                                    message: ""
                                }
                            }]
                        },
                        {
                            type: "template",
                            template: afterCredentialCompletionsByBefore2Template,
                            dataSourceName: "data",
                            dataSetPath: "p3AfterCredentialCompletionsCountByBefore",
                             errorConditions: [{
                                valuePath: "data",
                                is: null,
                                error: {
                                    type: "NoData",
                                    message: ""
                                }
                            }]
                        },
                        {
                            type: "template",
                            template: "<h5>  Highest Credential Completed After Transfer</h5>"
                        },
                        {
                            type: "bar",
                            dataSourceName: "data",
                            dataSetPath: "p3AfterXferHighestAward",
                            dataPath: "p3AfterXferHighestAward.data",
                            dataShape: "pointsWithinRows",
                            dataDimensions: 2,
                            //convertDataHashToArray: true,

                            // DISPLAY
                            //xAxisLabelPath: "metric[1].name",
                            unitString: "",
                            unitDec: 0,
                            showLegend: true,
                            // yAxisMax: 5000,
                            yAxisMaxPath: "yMax",
                            dataLabels: true,

                            // SERIES
                            // each series has two points, and is an organization
                            series: [{
                                dataPath: "slice",
                                valuePath: "count",
                                seriesDisplayNamePath: "orgName",
                                displayNamePath: "name",
                            }],
                            errorConditions: [{
                                valuePath: "data.meta.dataNotAvailableMessage",
                                isNot: null,
                                error: {
                                    type: "NoData",
                                    messagePath: "data.meta.dataNotAvailableMessage"
                                }
                            }] 
                        },
                        {
                            type: "template",
                            template: afterXferHighestAwardTemplate,
                            dataSourceName: "data",
                            dataSetPath: "p3AfterXferHighestAward",
                            errorConditions: [{
                                valuePath: "data",
                                is: null,
                                error: {
                                    type: "NoData",
                                    message: ""
                                }
                            }]
                        },
                        {
                            type: "template",
                            template: "<h5>Total Number of Institutions Attended as of Last Data Reported Among Those with Known Origin Institution</h5>"
                        },
                        {
                            // SETUP
                            type: "pie",
                            dataSourceName: "data",
                            dataPath: "p3TotalInstCount.data[0].slice",
                            dataShape: "pointsWithinRows",
                            convertDataHashToArray: true,
                            dataDimensions: 1,
                            title: "",

                            // DISPLAY
                            unitString: "%",
                            unitDec: 0,
                            showLegend: true,
                            dataLabels: false,

                            // SERIES (only one series, this is a simple graph)
                            series: [{
                                valuePath: "percent",
                                displayNamePath: "name",
                                longDisplayNamePath: "name",
                            }],
                            errorConditions: [{
                                valuePath: "data",
                                is: null,
                                error: {
                                    type: "NoData",
                                    message: "Data is not available for current selection(s)."
                                }
                            }]

                        },
                        {
                            type: "template",
                            template: totalInstCountTemplate,
                            dataSourceName: "data",
                            dataSetPath: "p3TotalInstCount",
                             errorConditions: [{
                                valuePath: "data",
                                is: null,
                                error: {
                                    type: "NoData",
                                    message: ""
                                }
                            }]
                        },
                        {
                            type: "template",
                            template: "<h6 class='reportSubhead'>Average Number of Total Institutions Attended</h6> {{data.average}}",
                            dataSourceName: "data",
                            dataPath: "p3TotalInstCount",
                             errorConditions: [{
                                valuePath: "data",
                                is: null,
                                error: {
                                    type: "NoData",
                                    message: ""
                                }
                            }]
                        },
                    ]
                },
                {
                    title: "More Information</span>",
                    visibleByDefault: true,
                    openByDefault: false,
                    views: [{
                        type: "template",
                        template: '<p><a href="/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&amp;IBIF_ex=sledsws_getdata_PSXfer.fex&amp;orgId=999999000&amp;orgName=Statewide&amp;groupType=state&amp;psxferCOHORTID=2021&amp;outputFormat=XLSX" data-role="button" target="_blank" class="ui-link ui-btn ui-shadow ui-corner-all" role="button">Download All Data</a></p><p>For more information on transfer students, please visit the <a href="https://education.mn.gov/mdeprod/idcplg?IdcService=GET_FILE&dDocName=059077&RevisionSelectionMethod=latestReleased&Rendition=primary" target="_blank">Data Interpretation Guide</a> and <a href="http://www.ohe.state.mn.us/sPages/TransferStudents.cfm" target="_blank">Transfer Students dashboard</a>.  The <b><i>download all</i></b> data button downloads the data in the reports listed above.</p><p><a href="https://education.mn.gov/mdeprod/idcplg?IdcService=GET_FILE&dDocName=PROD070132&RevisionSelectionMethod=latestReleased&Rendition=primary" target="_blank">Download web report data</a> for all colleges or systems and years results in a large Excel file of all the data. Please note this file does not include subgroup statistics. For more information, <a href="https://education.mn.gov/mdeprod/idcplg?IdcService=GET_FILE&dDocName=mde031756&RevisionSelectionMethod=latestReleased&Rendition=primary" target="_blank">read the help document</a>.</p>'

                    }]
                }
            ],
            filterSources: {
                orgs: {
                    modelType: SLEDSModels.SLEDSOrgList,
                    url: "ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_filter_PSXfer_orgid.fex",
                    noViewParams: true,
                    enabled: true
                },
                filters: {
                    modelType: CardboardModels.FilterData,
                    url: "/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_filter_PSXfer_cohortid.fex",
                    enabled: true
                },
                filters2: {
                    modelType: CardboardModels.FilterProducer,
                    filterSources: ["filterForReport"],
                    urls: {
                        filterForReport: "/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_filter_PSXfer_dropdowns.fex"
                    },
                    enabled: true,
                },
              /*   filters2: {
                    modelType: CardboardModels.FilterData,
                    url: "",
                    enabled: true
                }, */
                demographicCategories: {
                    modelType: CardboardCollections.DemoCatProducer,
                    url: "/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_filter_PSXfer_buttons.fex",
                    enabled: true,
                    noViewParams: false,
                    isCat: true
                }
            },
            dataSources: {
                data: {
                    modelType: CardboardModels.DocumentModel,
                    url: "/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_PSXfer.fex",
                    yearPath: "dataYear",
                    defaultParams: {
                        orgId: 999999000
                    },
                    paramMappings: {
                        PS_ORGID: "orgId",
                        orgName: null // skip this
                    },
                    /*         postProcessor: function (data) {
                                            // all we need to do is prettify all the org names!

                                            var blobs = [
                                            data.collegeEnrollment.slices,
                                            data.enrollmentOptions.slices,
                                            data.firstYearCredits.slices,
                                            data.developmentalCredits.slices,
                                            data.topTenInstitutions.institutions
                                        ];

                                            _(blobs).each(function (slices) {
                                                _(slices).each(function (slice) {
                                                    _(slice.organizations).each(function (org) {
                                                        org.orgName = Util.Data.prettifyName(org.orgName);
                                                    });
                                                });
                                            });
                                        },*/
                    enabled: true,
                    errorConditions: [{
                        valuePath: "errorMessage",
                        isNot: null,
                        error: {
                            type: "NoData",
                            message: "Data is not available for current selection(s)."
                        }
                    }]
                }
            }
        };

        return exports;
    });
